const html = require("./html/shippingQuoteReviewView.html");
import {setElementsFromScope, insertTextAndClean, swapClassesViaBool, boolToHuman, swapClasses, insertValAndManageFocus, show, hide, handleDisplayForV2} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";
import {toWeekDayMonthAndDay} from "../../../utilities/general";
import {toCurrency} from "../../../utilities/currency";

const elementsMap = {
  estimatedPickupDate: ".estimated-pickup-date-val",
  estimatedTransitTime: ".estimated-transit-time-val",
  estimatedCost: ".estimated-cost-val"
};

export default function ShippingQuoteReviewView(_unused, {
  getAsn,
  getQuote,
  isPallet
}){
  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
  }

  function updateSelf(){
    updateValues();
  }

  function updateValues(){
    const quote = getQuote();
    if(quote){
      insertTextAndClean(els.estimatedPickupDate, toWeekDayMonthAndDay(quote.estimatedPickupDate));
      insertTextAndClean(els.estimatedTransitTime, quote.estimatedTransitTime);
      insertTextAndClean(els.estimatedCost, toCurrency(quote.estimatedCost));
    }
  }



  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.unbindListener("asns:change", updateSelf);
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/ShippingQuoteReviewView.js